import { ReactComponent as DashboardComplaintTracking } from '../assett/icons/complaint_tracking_menu.svg';
import { ReactComponent as DashboardViewSettlementLetters } from '../assett/icons/envelope_icon.svg';
import { ReactComponent as DashboardFraudTracking } from '../assett/icons/fraud_tracking_menu.svg';
import { ReactComponent as HomeIcon } from '../assett/icons/home_icon.svg';
import { ReactComponent as SharedLogout } from '../assett/icons/logout_menu_icon.svg';
import { ReactComponent as DashboardViewBilling } from '../assett/icons/view_billing_menu.svg';
import { ReactComponent as DashboardViewClaims } from '../assett/icons/view_claims_menu.svg';

export interface IAction {
	id: string;
	name: string;
	link: string;
	icon: React.ReactNode;
	unselected_route?: string | React.ReactNode;
}

export const Home = (t: (t: string) => string) => [
	{
		id: 'dashboard_button_home',
		name: t('dashboard.buttons.home'),
		link: '/',
		icon: <HomeIcon />,
		show: true,
	},
];

export const Dashboard_Sections = (
	t: (t: string) => string,
	selected: boolean,
) => [
	// {
	// 	id: 'dashboard_button_view_clients',
	// 	name: t('dashboard.buttons.clients'),
	// 	link: '/view-clients',
	// 	icon: <DashboardViewClients />,
	// 	// unselected_route: <DashboardViewClaims />,
	// 	show: true,
	// 	feature: ['view-clients'],
	// },
	// {
	// 	id: 'dashboard_button_view_carriers',
	// 	name: t('dashboard.buttons.carriers'),
	// 	link: '/view-carriers',
	// 	icon: <DashboardViewCarriers />,
	// 	// unselected_route: <DashboardViewClaims />,
	// 	show: true,
	// 	feature: ['view-carriers'],
	// },
	// {
	// 	id: 'dashboard_button_view_groups',
	// 	name: t('dashboard.buttons.groups'),
	// 	link: '/view-groups',
	// 	icon: <DashboardViewGroups />,
	// 	show: true,
	// 	feature: ['view-groups'],
	// },
	// {
	// 	id: 'dashboard_button_view_providerNetworks',
	// 	name: t('dashboard.buttons.providerNetworks'),
	// 	link: '/view-providerNetworks',
	// 	icon: <DashboardViewProviderNetworks />,
	// 	show: true,
	// 	feature: ['view-provider-networks'],
	// },
	// {
	// 	id: 'dashboard_button_view_Members',
	// 	name: t('dashboard.buttons.members'),
	// 	link: '/view-members',
	// 	icon: <DashboardViewMembers />,
	// 	show: true,
	// 	feature: ['view-members'],
	// },
	// {
	// 	id: 'dashboard_button_view_plans',
	// 	name: t('dashboard.buttons.plans'),
	// 	link: '/view-plans',
	// 	icon: <DashboardViewPlans />,
	// 	show: true,
	// 	feature: ['view-plans'],
	// },
	// {
	// 	id: 'dashboard_button_view_benefits',
	// 	name: t('dashboard.buttons.benefits'),
	// 	link: '/view-benefits',
	// 	icon: <DashboardViewBenefits />,
	// 	// unselected_route: <DashboardViewClaims />,
	// 	show: true,
	// 	feature: ['view-benefits'],
	// },
	{
		id: 'dashboard_button_view_claims',
		name: t('dashboard.buttons.claims'),
		link: '/view-claims',
		icon: <DashboardViewClaims />,
		// unselected_route: <DashboardViewClaims />,
		show: true,
		feature: ['view-claims'],
	},
	{
		id: 'dashboard_button_view_billing',
		name: t('dashboard.buttons.billing'),
		link: '/view-billing',
		icon: <DashboardViewBilling />,
		// unselected_route: <DashboardViewClaims />,
		show: true,
		feature: ['view-billing'],
	},
	{
		id: 'dashboard_button_view_settlement_letters',
		name: t('dashboard.buttons.settlementLetters'),
		link: '/view-settlement-letters',
		icon: <DashboardViewSettlementLetters />,
		// unselected_route: <DashboardViewClaims />,
		show: true,
		feature: ['view-settlement-letters'],
	},
	{
		id: 'dashboard_button_view_complaint_tracking',
		name: t('dashboard.buttons.complaintTracking'),
		link: '/view-complaint-tracking',
		icon: <DashboardComplaintTracking />,
		show: true,
		feature: ['view-complaint-tracking'],
	},
	{
		id: 'dashboard_button_view_fraud_tracking',
		name: t('dashboard.buttons.fraudTracking'),
		link: '/view-fraud-tracking',
		icon: <DashboardFraudTracking />,
		show: true,
		feature: ['view-fraud-tracking'],
	},
	// {
	// 	id: 'dashboard_button_view_users',
	// 	name: t('dashboard.buttons.users'),
	// 	link: '/view-users',
	// 	icon: <DashboardViewUsers />,
	// 	// unselected_route: <DashboardViewClaims />,
	// 	show: true,
	// 	feature: ['view-users'],
	// },
	// {
	// 	id: 'dashboard_button_view_reporting',
	// 	name: t('dashboard.buttons.reporting'),
	// 	link: '/view-reporting',
	// 	icon: <DashboardViewReporting />,
	// 	// unselected_route: <DashboardViewClaims />,
	// 	show: true,
	// 	feature: ['view-reporting'],
	// },
];

// export const Dashboard_ManageAccount = (t: (t: string) => string) => [
// 	{
// 		id: 'dashboard_button_location_information',
// 		name: t('dashboard.buttons.locationInformation'),
// 		link: '/location-information',
// 		icon: <DashboardLocationInformationSelected />,
// 		unselected_route: <DashboardLocationInformation />,
// 		show: true,
// 	},
// 	{
// 		id: 'dashboard_button_view_payments',
// 		name: t('dashboard.buttons.viewPayments'),
// 		link: '/view-payment-history',
// 		icon: <DashboardViewPaymentSelected />,
// 		unselected_route: <DashboardViewPayment />,
// 		show: true,
// 	},
// ];

// export const Dashboard_Go = (t: (t: string) => string) => [
// 	{
// 		id: 'dashboard_button_go_to_essilor',
// 		name: t('dashboard.buttons.goToEssilor'),
// 		link: 'https://google.com',
// 		icon: <DashboardGoToMyessilor />,
// 		show: true,
// 	},
// 	{
// 		id: 'dashboard_button_go_to_training',
// 		name: t('dashboard.buttons.goToTraining'),
// 		link: 'https://google.com',
// 		icon: <DashboardGoToTraining />,
// 		show: true,
// 	},
// ];

export const Logout = (t: (t: string) => string) => [
	{
		id: 'dashboard_buttons_logout',
		name: t('dashboard.buttons.logout'),
		link: '/login',
		icon: <SharedLogout />,
		show: true,
	},
];

export const OutboundLinks = {
	becomingAProvider: {
		href: 'https://google.com',
		target: '_blank',
	},
	cookiesBanner: {
		href: 'https://google.com',
		target: '_blank',
	},
};
